// extracted by mini-css-extract-plugin
export default {"formLayout":"braform-module-formLayout-GyBKs","error":"braform-module-error-VJ9hi"};